import contact from 'src/i18n/fr/validations/contact';
import creditcard from 'src/i18n/fr/validations/creditcard';
import login from 'src/i18n/fr/validations/login';
import invoice from 'src/i18n/fr/validations/invoice';
import organisation from 'src/i18n/fr/validations/organisation';
import fundraising from 'src/i18n/fr/validations/fundraising';

const validations = {
  contact,
  creditcard,
  fundraising,
  invoice,
  login,
  organisation,
};

export default validations;
